import React, { createContext, useReducer } from "react";
import jwtDecode from "jwt-decode";

const LOGIN_ACTION = "LOGIN";
const LOGOUT_ACTION = "LOGOUT";
const TOKEN = "TLFPL_JWTTOKEN";

const initialState = {
  user: null,
};

if (localStorage.getItem(TOKEN)) {
  const decodedToken = jwtDecode(localStorage.getItem(TOKEN));

  if (decodedToken.exp * 1000 < Date.now()) {
    localStorage.removeItem(TOKEN);
  } else {
    initialState.user = decodedToken;
  }
}

const AuthContext = createContext({
  user: null,
  login: (userData) => {},
  logout: () => {},
});

const authReducer = (state, action) => {
  switch (action.type) {
    case LOGIN_ACTION:
      return {
        ...state,
        user: action.payload,
      };
    case LOGOUT_ACTION:
      return {
        ...state,
        user: null,
      };
    default:
      return state;
  }
};

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const login = (userData) => {
    localStorage.setItem(TOKEN, userData.token);
    dispatch({
      type: LOGIN_ACTION,
      payload: userData,
    });
  };

  const logout = () => {
    localStorage.removeItem(TOKEN);
    dispatch({
      type: LOGOUT_ACTION,
    });
  };

  return (
    <AuthContext.Provider
      value={{ user: state.user, login, logout }}
      {...props}
    />
  );
}

export { AuthContext, AuthProvider };
